import { useSelector } from 'react-redux';

export const GetSelectedTab = (page) => {
    let allTabs = useSelector(state => state.Tabs.allTabs);
    return allTabs[page];
};
export default GetSelectedTab;